import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, Home, HelpCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const DonationCancelPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-6">
      <motion.div 
        className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex justify-center mb-6">
          <XCircle size={64} className="text-gray-400" />
        </div>
        
        <h1 className="font-display text-h2 text-secondary mb-4">Donation Cancelled</h1>
        
        <p className="text-textPrimary mb-6">
          Your donation process was cancelled. No charges were made to your payment method.
        </p>
        
        <div className="bg-lightTeal rounded-lg p-4 mb-6">
          <p className="text-secondary font-body">
            Would you like to try again or have questions about the donation process?
            We're here to help.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <motion.button 
              className="flex items-center justify-center w-full sm:w-auto px-6 py-3 bg-white border-2 border-primary text-primary rounded-xl font-bold transition-all"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Home size={18} className="mr-2" />
              Return Home
            </motion.button>
          </Link>
          
          <Link to="/donation">
            <motion.button 
              className="flex items-center justify-center w-full sm:w-auto px-6 py-3 bg-cta text-white rounded-xl font-bold shadow-md transition-all"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Try Again
            </motion.button>
          </Link>
        </div>
        
        <Link to="/contact" className="flex items-center justify-center mt-6 text-primary font-medium hover:underline">
          <HelpCircle size={16} className="mr-1" />
          Need help? Contact us
        </Link>
      </motion.div>
    </div>
  );
};

export default DonationCancelPage;